import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import { Divider, Stack } from '@mui/material';
import { AccountSelector } from './AccountSelector';
import { MoneyInput } from '@pflegenavi/web-components';
import type { FC } from 'react';
import React from 'react';
import type { CashList } from '@pflegenavi/frontend/api-nursing-home';

import { useTransferFormStore } from './TransferFormStoreProvider';

interface HeaderProps {
  readonly: boolean;
  outgoingCashLists: CashList[];
  incomingCashLists: CashList[];
}

export const Header: FC<HeaderProps> = ({
  readonly,
  outgoingCashLists,
  incomingCashLists,
}) => {
  const { t } = useTranslation();

  const [targetAmount, setTargetAmount] = useTransferFormStore(
    useShallow((state) => [state.targetAmount, state.setTargetAmount])
  );

  return (
    <Stack
      direction="row"
      sx={{
        gap: 0,
      }}
    >
      <Stack
        direction="column"
        sx={{
          gap: 2,
          flex: 1,
          minWidth: 240,
          paddingY: 1,
        }}
      >
        <AccountSelector
          disabled={readonly}
          bucket={'from'}
          cashLists={outgoingCashLists}
        />
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            maxWidth: 350,
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <MoneyInput
            autoFocus={true}
            size="small"
            value={targetAmount}
            onChange={setTargetAmount}
            disabled={readonly}
            label={t('common.amount')}
            slotProps={{ inputLabel: { shrink: true } }}
          />
        </Stack>
      </Stack>
      <Stack
        direction={'row'}
        sx={{
          flex: 1,
          maxWidth: 60,
          justifyContent: 'center',
        }}
      >
        <Divider flexItem orientation="vertical" variant="middle"></Divider>
      </Stack>
      <Stack
        direction="column"
        sx={{
          flex: 1,
          minWidth: 240,
          paddingY: 1,
        }}
      >
        <AccountSelector
          disabled={readonly}
          bucket={'to'}
          cashLists={incomingCashLists}
        />
      </Stack>
    </Stack>
  );
};
